import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { Helmet } from 'react-helmet';
import { colors } from '../../../theme';

export const ApplicationSilentLoginPage = () => {
  return (
    <>
      <Helmet>
        <title>
          Guides | Application Single Sign On and Silent Login | Cotality
          Developer Portal
        </title>
      </Helmet>

      <Box flex={1} bgcolor="white">
        <Box maxWidth={1440} m="auto" px={4} pt={4} pb={8}>
          {/* Application Single Sign On Section */}
          <Typography
            variant="h3"
            fontFamily="TWK Everett"
            fontWeight={600}
            my={0.5}
          >
            Application Single Sign On
          </Typography>
          <br />
          <Typography variant="body2">
            Application Single Sign-On (SSO) is a method that allows users to
            access multiple applications with a single login. Instead of needing
            to remember and enter different usernames and passwords for each
            application, users log in once, and their credentials are used to
            authenticate them across all authorized applications. This
            simplifies the login process, enhances user experience, and reduces
            the risk of password fatigue and security breaches.
            <br />
            <br />
            Cotality offers{' '}
            <Link
              target="_blank"
              href="https://auhelpcentre.corelogic.com.au/hc/en-au/articles/8008725409423-SAML-Configuration-for-SP-Initiated-SSO-Flow"
            >
              SSO SAML authentication capability - see the Help Centre for
              details.
            </Link>
          </Typography>
          <br />

          <Typography variant="body2" fontWeight={500}>
            Notes:
          </Typography>

          <Typography variant="body2" color={colors.red}>
            <ul>
              <li>
                SSO is not supported in all applications currently, but efforts
                are being made to enable it in the future.
              </li>
              <li>
                SSO is not an authentication method for APIs. It is intended for
                user login flows and session management.
              </li>
            </ul>
          </Typography>

          <br />
          <br />

          {/* Silent Login Section */}
          <Typography
            variant="h3"
            fontFamily="TWK Everett"
            fontWeight={600}
            my={0.5}
          >
            Silent Login
          </Typography>
          <br />
          <Typography variant="body2">
            Silent Login deep linking is an alternative authentication mechanism
            to support platforms that wish to provide their users with a simple
            way to access Cotality data. This allows platforms to not only
            display Cotality data directly within their platform, it provides
            the ability to redirect their users to RP Data or Property Guru
            websites for additional data and functionality without explicitly
            logging in. User authentication is provided from within the clients
            platform, which can then be subsequently used to avoid repeated
            login requests.
          </Typography>
          <br />
          <Typography variant="body2">
            Silent Login and deep linking requires the end user of the
            integrating platform to be a current subscriber of RP Data or
            Property Guru, and as such that they hold a valid username, password
            and account subscription. The technical difference from API
            Authentication is obtaining a User Token via an authorization code
            grant, rather than a more limited API token client credential grant.
          </Typography>
          <br />
          <Typography variant="h6" fontWeight={600} my={0.5}>
            RP.Inside User Authentication Technical Guide
          </Typography>
          <Typography variant="body2">
            <Link
              href="/assets/files/RPInside%20-%20User%20Auth%20and%20Silent%20Login%20V4.0.pdf"
              target="_blank"
            >
              RP.Inside Authentication v4.0 PDF
            </Link>
          </Typography>
          <br />
          <Typography variant="body2">
            <Link
              download="CL RP.Inside Auth Example_postman_collection.json"
              title="Postman Example - CL RP.Inside Auth"
              href="https://content.api.cotality.com.au/docs/public/deep-link-postman.json"
            >
              This sample postman collection
            </Link>{' '}
            demonstrates Authorization Code Grant and Application Silent login
            as documented above.
          </Typography>
          <br />

          <Typography variant="body2" fontWeight={500}>
            Note:
          </Typography>

          <Typography variant="body2" color={colors.red}>
            <ul>
              <li>
                Silent Login is not an authentication method for APIs. It is
                designed for user-level access and redirection, not for backend
                API integration.
              </li>
            </ul>
          </Typography>
        </Box>
      </Box>
    </>
  );
};
